import React from 'react';
import Features from './Features';

const About = () => {
  return (
    <>
      <Features />
    </>
  );
};

export default About;
